







































import { Watch, Prop, Component, Vue } from 'vue-property-decorator'
import { PipelineConnection } from '@/api/model/pipeline-connection'
import { InputSelectOption } from '@/helpers/options'
import { Pipeline } from '@/api/model/pipeline'
import { PipelineAPI } from '@/api/backend-client'
import InputSwitch from '@/components/input/InputSwitch.vue'
import InputSelect from '@/components/input/InputSelect.vue'
import LoaderBalls from '@/components/LoaderBalls.vue'
import TooltipDecorator from '@/components/input/label/decorator/TooltipDecorator.vue'

@Component({
    components: {
        InputSwitch,
        InputSelect,
        LoaderBalls,
        TooltipDecorator,
    },
})
export default class EditOutgoingPipelineConnection extends Vue {
    @Prop({ required: true }) readonly pipelineConnection!: PipelineConnection
    pipelines: Pipeline[] = []
    internalValue: PipelineConnection = null
    loading: boolean = false

    created(): void {
        this.internalValue = this.pipelineConnection
    }

    async mounted(): Promise<void> {
        this.loading = true
        this.pipelines = await PipelineAPI.getAll({
            company: this.pipelineConnection.targetCompany.id,
        })
        this.loading = false
    }

    @Watch('pipelineConnection')
    onPipelineConnectionChanged(): void {
        this.internalValue = this.pipelineConnection
    }

    @Watch('internalValue')
    onInternalValueChanged(): void {
        this.$emit('input', this.internalValue)
    }

    get currentPipelineId(): string|null {
        return this.internalValue.pipeline?.id || null
    }

    set currentPipelineId(value) {
        this.internalValue.pipeline = this.pipelines.find(p => p.id === value)
    }

    get availablePipelines(): InputSelectOption[] {
        return this.pipelines
            .map(entry => ({
                label: entry.name,
                value: entry.id,
            }))
    }
}
